import { defineMessage } from 'services/localization';

export const messages = {
    selectPlaceholder: defineMessage('select'),
    payeeBankCountry: defineMessage('bank_account_country'),
    payerBankCountry: defineMessage('contact_country'),
    accountCurrency: defineMessage('account_currency'),
    confirmChanges: defineMessage('confirm_changes_1'),
    confirmChangesDescription: defineMessage('are_you_sure_you_want_t_details_will_be_cleared'),
    confirm: defineMessage('confirm'),
};
